import { createFileRoute } from '@tanstack/react-router'

import { SalesPipelineScreen } from './-components/pipeline-screen.tsx'

export const Route = createFileRoute('/sales/pipeline')({
  component: SalesPipelineScreen
})
